import styled from '@emotion/styled'

export const StyleWrapper = styled.div`
  padding: 16px;
  border-radius: 12px;
  box-shadow: ${(props: any) => props.theme.colors.boxShadow};
  background-color: ${(props: any) => props.theme.colors.white};

  @media (max-width: 768px) {
    padding: 8px;
  }
`
